import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["paymentMethodField", "cashButton", "cardButton", "paymentForm", "cashFeeText", "cardFeeText"]

  connect() {
    // Initialize visibility based on current payment method
    this.updateVisibility()
  }

  selectCash(event) {
    event.preventDefault()
    this.paymentMethodFieldTarget.value = "cash"
    this.hidePaymentForm()
    this.updateActiveButton("cash")
    this.updateFeeText("cash")
  }

  selectCard(event) {
    event.preventDefault()
    this.paymentMethodFieldTarget.value = "card"
    this.showPaymentForm()
    this.updateActiveButton("card")
    this.updateFeeText("card")
  }

  hidePaymentForm() {
    if (this.hasPaymentFormTarget) {
      this.paymentFormTarget.style.display = "none"
    }
  }

  showPaymentForm() {
    if (this.hasPaymentFormTarget) {
      this.paymentFormTarget.style.display = "block"
    }
  }

  updateActiveButton(selectedMethod) {
    // Remove active class from both buttons (if they exist)
    if (this.hasCashButtonTarget) {
      this.cashButtonTarget.classList.remove("product-thumb-active")
    }
    if (this.hasCardButtonTarget) {
      this.cardButtonTarget.classList.remove("product-thumb-active")
    }

    // Add active class to selected button (if it exists)
    if (selectedMethod === "cash" && this.hasCashButtonTarget) {
      this.cashButtonTarget.classList.add("product-thumb-active")
    } else if (selectedMethod === "card" && this.hasCardButtonTarget) {
      this.cardButtonTarget.classList.add("product-thumb-active")
    }
  }

  updateVisibility() {
    const currentMethod = this.paymentMethodFieldTarget.value
    if (currentMethod === "card") {
      this.showPaymentForm()
      this.updateActiveButton("card")
      this.updateFeeText("card")
    } else {
      this.hidePaymentForm()
      this.updateActiveButton("cash")
      this.updateFeeText("cash")
    }
  }

  updateFeeText(selectedMethod) {
    // Show appropriate fee text based on payment method
    if (selectedMethod === "cash") {
      // Show cash fee text, hide card fee text
      if (this.hasCashFeeTextTarget) {
        this.cashFeeTextTarget.style.display = ""
      }
      if (this.hasCardFeeTextTarget) {
        this.cardFeeTextTarget.style.display = "none"
      }
    } else if (selectedMethod === "card") {
      // Show card fee text, hide cash fee text
      if (this.hasCashFeeTextTarget) {
        this.cashFeeTextTarget.style.display = "none"
      }
      if (this.hasCardFeeTextTarget) {
        this.cardFeeTextTarget.style.display = ""
      }
    }
  }
}
